import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

interface IModalPrexistenceProps {
  open: boolean;
  toggle: any;
  submit: () => void
}

export default function ModalConfirmHealth(props: IModalPrexistenceProps) {
  const { open, toggle, submit } = props;

  return (
    <Modal isOpen={open} modalClassName="format-new-modal-2" size="lg">
      <ModalBody>
        <div className="w-100">
          <div className="d-flex justify-content-end align-content-center align-items-center">
            <img 
              src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
              className="cursor-pointer"
              alt=""
              onClick={toggle(false)}
            />
          </div>
          <div className="modal-body-content">
            <h4 className="px-20">Estado de Salud</h4>
            <p className="px-14">
              Usted está declarando que ninguno de los asegurados inscritos presenta alguna de las enfermedades, dolencias o situaciones antes mencionadas.<br /><span className="w-100 p-0 m-0 mb-10"/>
              Entendiendo y aceptando que cualquier omisión, declaración falsa o errónea, faculta a la compañía aseguradora para rechazar el pago de la indemnización reclamada, o poner término anticipado a todas las coberturas, formando esta declaración parte integrante de las condiciones del seguro contratado.</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="modal-footer col-12 col-sm-10 col-lg-8 mx-auto">
        <button
          onClick={submit}
          className="btn primary go-to-product-description px-26"
        >
          Aceptar
        </button>
      </ModalFooter>
    </Modal>
  );
}
